module.exports = {"apiURL":"http://localhost:3900/api"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 11
// module chunks = 0